
import React from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { JobSearchFormData } from '../JobSearchFormSchema';

interface FormInputTextFieldProps {
  name: keyof JobSearchFormData;
  control: Control<JobSearchFormData>;
  label: string;
  placeholder: string;
  error?: FieldError;
  disabled?: boolean; // Added disabled prop
}

export const FormInputTextField: React.FC<FormInputTextFieldProps> = ({ name, control, label, placeholder, error, disabled }) => {
  const fieldId = String(name); // Convert to string for HTML id attribute
  
  return (
    <div>
      <Label htmlFor={fieldId} className={disabled ? 'text-muted-foreground' : ''}>{label}</Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <Input id={fieldId} {...field} value={field.value || ''} placeholder={placeholder} disabled={disabled} />}
      />
      {error && <p className="text-red-500 text-sm">{error.message}</p>}
    </div>
  );
};
